import InitialsAvatar from '@/components/ui/InitialsAvatar';

type AgentCardProps = {
  agentName: string;
  agentEmail: string;
  agentPhone: string | null;
  agentImage: string | null;
};

export default function AgentCard({ agentName, agentEmail, agentPhone, agentImage }: AgentCardProps) {
  return (
    <div className="w-full p-6 bg-white rounded-2xl border border-gray-200 flex gap-3 items-center">
      <div className="md:w-20 md:h-20 w-15 h-15 rounded-full overflow-hidden shrink-0">
        {agentImage ? (
          <img src={agentImage} alt="Agent" className="w-full h-full object-cover" />
        ) : (
          <InitialsAvatar name={agentName} className="w-full h-full" />
        )}
      </div>
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-2">
          <h3 className="text-xl font-semibold text-black">{agentName}</h3>
        </div>

        <div className="text-base font-normal text-[#4A5565]">{agentEmail}</div>

        <div className="text-base font-normal text-[#4A5565]">{agentPhone || 'N/A'}</div>
      </div>
    </div>
  );
}
